// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PaymentLineType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        OrderLineDetail: 1,
        Freight: 2,
        NorthPointFee: 3,
        OverPayment: 4,
        Credit: 5,
        Tax: 6,
        Fee: 7,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
}

